import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import Stack from "@mui/material/Stack";
import { grey } from "@mui/material/colors";
import NumberTextField from "components/ReusableComponents/NumberTextField";
import { datatypes } from "data/globalData";
import { LightTooltip } from "../CustomToolTip/CustomToolTip";

const TextInputField = ({
	data,
	setData,
	column,
	width,
	required,
	type,
	sx,
	disabled,
	onChange,
	disableLabel,
	variant,
	error = false,
	...rest
}) => {
	return (
		<Stack sx={{ width }} height={"40px"} direction="row">
			{!disableLabel && (
				<LightTooltip title={column?.name + (required ? "*" : "")} placement="bottom-start" arrow>
					<InputLabel
						sx={{
							width: "38%",
							borderRadius: "1px 0px 0px 1px",
							p: 1,
							background: "#000",
							overflow: "hidden",
							color: grey[100],
						}}>
						{column?.name} {required && <span style={{ color: "red" }}>*</span>}
					</InputLabel>
				</LightTooltip>
			)}
			{column?.data_type === datatypes.NUMBER.key || column?.data_type === datatypes.DECIMAL.key ? (
				<NumberTextField
					variant={variant ? variant : "outlined"}
					size="small"
					sx={sx}
					disableHelperText
					disabled={disabled}
					onChange={onChange}
					value={data && data[column.key] ? data[column.key] : 0}
					error={error}
					{...rest}
				/>
			) : column.data_type === datatypes.FILE.key ? (
				<TextField
					variant={variant ? variant : "outlined"}
					sx={sx}
					size="small"
					error={error}
					type={datatypes.FILE.htmlVar}
					onChange={onChange}
					disabled={disabled}
					placeholder={`Select ${column?.key}`}
					required={required ? required : false}
					fullWidth
					{...rest}
				/>
			) : (
				<TextField
					variant={variant ? variant : "outlined"}
					sx={sx}
					size="small"
					error={error}
					type={datatypes[column?.data_type] ? datatypes[column?.data_type].htmlVar : "text"}
					value={data && data[column.key] ? data[column.key] : ""}
					onChange={onChange}
					disabled={disabled}
					placeholder={`Enter ${column?.key}`}
					required={required ? required : false}
					fullWidth
					{...rest}
				/>
			)}
		</Stack>
	);
};

export default TextInputField;
